(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lf-age-gate"] && !Shopify.designMode) return;
  try {
    (()=>{const dialog=document.getElementById('lf-age');if(!dialog)return;let accepted=false;try{accepted=sessionStorage.getItem('lf-adult')==='yes'}catch{}if(accepted)return;dialog.showModal();document.getElementById('lf-age-title').focus({preventScroll:true});const oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.addEventListener('cancel',e=>e.preventDefault());document.getElementById('lf-age-yes').addEventListener('click',()=>{try{sessionStorage.setItem('lf-adult','yes')}catch{}dialog.close();document.documentElement.style.overflow=oldOverflow});document.getElementById('lf-age-no').addEventListener('click',()=>{document.getElementById('lf-age-actions').hidden=true;document.getElementById('lf-age-denied').hidden=false;document.getElementById('lf-age-back').focus()});document.getElementById('lf-age-back').addEventListener('click',()=>{document.getElementById('lf-age-actions').hidden=false;document.getElementById('lf-age-denied').hidden=true;document.getElementById('lf-age-title').focus({preventScroll:true})})})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lf-cart-delivery-script"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('lf-cart-delivery')) return;
  let address = null;
  let savedZip = '';
  try { savedZip = sessionStorage.getItem('lf_delivery_cep') || ''; } catch (_) {}
  const root = () => window.Shopify?.routes?.root || '/';
  const capital = zip => /^(0[1-5]|08[0-4])/.test(zip);
  const blocks = (count, zip) => count > 0 && count < 4 && !capital(zip);
  const all = () => [...document.querySelectorAll('lf-cart-delivery')];
  let quoteQueue = Promise.resolve();
  class LFCartDelivery extends HTMLElement {
    static get observedAttributes() { return ['data-count', 'data-signature', 'data-total']; }
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.input = this.querySelector('[data-cep]');
        this.input.value = savedZip;
        const signal = this.controller.signal;
        this.input.addEventListener('input', () => {
          this.input.value = this.input.value.replace(/\D/g, '').slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2');
          savedZip = this.input.value;
          address = null;
          try { sessionStorage.setItem('lf_delivery_cep', savedZip); } catch (_) {}
          all().forEach(el => { el.cancel(); if (el !== this && el.input) el.input.value = savedZip; el.render(); });
        }, {signal});
        this.input.addEventListener('keydown', event => {
          if (event.key === 'Enter') { event.preventDefault(); this.calculate(); }
        }, {signal});
        this.querySelector('[data-calculate]').addEventListener('click', () => this.calculate(), {signal});
        this.render();
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.cancel(); }
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue || !this.messages) return;
      this.cancel();
      this.render();
      if (name === 'data-signature') this.status(this.messages.changed);
    }
    cancel() {
      this.request?.abort();
      this.request = null;
      this.querySelector('[data-calculate]')?.removeAttribute('disabled');
      this.querySelector('[data-rates]')?.replaceChildren();
    }
    count() { return Number(this.dataset.count) || 0; }
    blocked() { return address && blocks(this.count(), address.zip); }
    render() {
      if (!this.messages) return;
      const count = this.count();
      const rule = this.querySelector('[data-rule]');
      const isBlocked = this.blocked();
      rule.dataset.blocked = String(Boolean(isBlocked));
      let message = this.messages.unknown;
      rule.hidden = count === 0 || count >= 4;
      if (!count || count >= 4) message = '';
      else if (address) {
        message = isBlocked ? this.messages.shortage.replace('{count}', String(4-count)) : capital(address.zip) ? this.messages.capital : this.messages.enough;
        message = address.city + ' / ' + address.uf + '. ' + message;
      }
      rule.textContent = message;
      if (isBlocked) {
        const match = message.match(/\d+ latas/);
        if (match) {
          const emphasis = document.createElement('strong');
          emphasis.className = 'lf-delivery-missing';
          emphasis.textContent = match[0];
          rule.replaceChildren(message.slice(0, match.index), emphasis, message.slice(match.index + match[0].length));
        }
      }
    }
    status(message) {
      const p = document.createElement('p'); p.textContent = message;
      this.querySelector('[data-rates]').replaceChildren(p);
    }
    async calculate() {
      this.cancel();
      const zip = this.input.value.replace(/\D/g, '');
      if (!/^\d{8}$/.test(zip)) { this.status(this.messages.invalid); this.input.focus(); return; }
      const controller = new AbortController();
      this.request = controller;
      const signal = controller.signal;
      const button = this.querySelector('[data-calculate]');
      button.disabled = true;
      const timer = setTimeout(() => controller.abort(), 25000);
      this.status(this.messages.loading);
      try {
        const lookup = await fetch('https://viacep.com.br/ws/' + zip + '/json/', {signal});
        if (!lookup.ok) throw new Error('lookup');
        const data = await lookup.json();
        if (data.erro || !data.uf || !data.localidade) { this.status(this.messages.missing); return; }
        if (signal.aborted) return;
        address = {zip, city:data.localidade, uf:data.uf};
        all().forEach(el => el.render());
        const params = new URLSearchParams({ 'shipping_address[zip]':zip, 'shipping_address[country]':'Brazil', 'shipping_address[province]':data.uf, 'shipping_address[city]':data.localidade });
        const work = async () => {
          if (signal.aborted) return;
          const prepare = await fetch(root() + 'cart/prepare_shipping_rates.json?' + params, {method:'POST', signal});
          if (!prepare.ok) throw new Error('rates');
          for (let i=0; i<12; i++) {
            if (signal.aborted) return;
            const response = await fetch(root() + 'cart/async_shipping_rates.json?' + params, {signal});
            if (!response.ok) throw new Error('rates');
            const result = await response.json();
            if (result !== null) {
              if (!Array.isArray(result.shipping_rates) || !result.shipping_rates.length) { this.status(this.messages.no_rates); return; }
              if (Number(this.dataset.total) >= 30000 && this.dataset.currency === 'BRL') {
                if (!signal.aborted) this.status(this.messages.free);
                return;
              }
              const list = document.createElement('ul');
              for (const rate of result.shipping_rates) {
                const row = document.createElement('li');
                const label = document.createElement('span'); label.textContent = rate.presentment_name || rate.name;
                const price = document.createElement('strong');
                price.textContent = new Intl.NumberFormat('pt-BR', {style:'currency', currency:rate.currency || this.dataset.currency || 'BRL'}).format(Number(rate.price));
                row.append(label,price); list.append(row);
              }
              if (!signal.aborted) this.querySelector('[data-rates]').replaceChildren(list);
              return;
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
          throw new Error('timeout');
        };
        const pending = quoteQueue.catch(() => {}).then(work);
        quoteQueue = pending;
        await pending;
      } catch (error) {
        if (this.request === controller) this.status(this.messages.failure);
      } finally {
        clearTimeout(timer);
        if (this.request === controller) { button.disabled=false; this.request=null; }
      }
    }
  }
  customElements.define('lf-cart-delivery', LFCartDelivery);
  const guard = event => {
    const checkout = event.type === 'submit' ? event.submitter?.matches('[name="checkout"]') : event.target.closest?.('[name="checkout"], a[href="/checkout"]');
    if (!checkout) return;
    const widget = all().find(el => el.getClientRects().length && el.messages);
    if (!widget) return;
    const needsCep = !address;
    if (!needsCep && !widget.blocked()) return;
    event.preventDefault(); event.stopImmediatePropagation();
    widget.render();
    if (needsCep) widget.status(widget.messages.required || widget.messages.hint);
    widget.scrollIntoView({behavior:'smooth',block:'center'});
    widget.input.focus({preventScroll:true});
  };
  document.addEventListener('click',guard,true);
  document.addEventListener('submit',guard,true);
})();
  } catch(e) { console.error(e); }
})();

})();
